import {
  TYPE_CLIENT_REQUEST,
  TYPE_CLIENT_SUCCESS,
  TYPE_CLIENT_CLEAN,
  BUSINESS_LINES_REQUEST,
  BUSINESS_LINES_SUCCESS,
  BUSINESS_LINES_CLEAN,
  SEGMENTATION_REQUEST,
  SEGMENTATION_SUCCESS,
  SEGMENTATION_CLEAN,
  COMPANY_REQUEST,
  COMPANY_SUCCESS,
  COMPANY_CLEAN,
  TERRITORIES_REQUEST,
  TERRITORIES_SUCCESS,
  TERRITORIES_CLEAN,
  POGS_REQUEST,
  POGS_SUCCESS,
  POGS_CLEAN,
  CURRENCIES_REQUEST,
  CURRENCIES_SUCCESS,
  CURRENCIES_CLEAN,
  PlACEMENTS_REQUEST,
  PlACEMENTS_SUCCESS,
  PlACEMENTS_CLEAN,
  REGISTER_CLIENT_REQUEST,
  REGISTER_CLIENT_SUCCESS,
  REGISTER_CLIENT_CLEAN,
  RESPONSABLE_REQUEST,
  RESPONSABLE_SUCCESS,
  RESPONSABLE_CLEAN,
  READ_ONE_CLIENT_REQUEST,
  READ_ONE_CLIENT_SUCCESS,
  READ_ONE_CLIENT_CLEAN,
  VALIDATE_CLIENT_REQUEST,
  VALIDATE_CLIENT_SUCCESS,
  VALIDATE_CLIENT_CLEAN,
  RESPONSABLE_POSITION_REQUEST,
  RESPONSABLE_POSITION_SUCCESS,
  RESPONSABLE_POSITION_CLEAN,
  STATUS_CLIENT_REQUEST,
  STATUS_CLIENT_SUCCESS,
  STATUS_CLIENT_CLEAN,
} from '../actions';

function clientReducer(state = {}, action) {
  const { type } = action;

  switch (type) {
    //change status client
    case STATUS_CLIENT_REQUEST:
      return {
        ...state,
        status: true,
      };

    case STATUS_CLIENT_SUCCESS:
      return {
        ...state,
        status: action.payload,
      };

    case STATUS_CLIENT_CLEAN:
      return {
        ...state,
        status: action.payload,
      };
    //get data cliente
    case VALIDATE_CLIENT_REQUEST:
      return {
        ...state,
        isValid: true,
      };

    case VALIDATE_CLIENT_SUCCESS:
      return {
        ...state,
        isValid: action.payload,
      };

    case VALIDATE_CLIENT_CLEAN:
      return {
        ...state,
        isValid: action.payload,
      };
    //get Responsable position
    case RESPONSABLE_POSITION_REQUEST:
      return {
        ...state,
        responsablePosition: null,
      };
    case RESPONSABLE_POSITION_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const { position, data } = action.payload;
      // eslint-disable-next-line no-case-declarations
      let newdataRv = JSON.stringify(data);

      if (typeof Storage !== 'undefined') {
        localStorage.setItem(position, newdataRv);
      }
      return {
        ...state,
        responsablePosition: [...state.responsablePosition, action.payload],
      };
    case RESPONSABLE_POSITION_CLEAN:
      return {
        ...state,
        responsablePosition: null,
      };
    //get data cliente
    case READ_ONE_CLIENT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case READ_ONE_CLIENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
      };

    case READ_ONE_CLIENT_CLEAN:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
      };
    //get Responsable
    case RESPONSABLE_REQUEST:
      return {
        ...state,
        responsable: null,
      };
    case RESPONSABLE_SUCCESS:
      return {
        ...state,
        responsable: action.payload,
      };
    case RESPONSABLE_CLEAN:
      return {
        ...state,
        responsable: null,
      };
    //get Placements
    case PlACEMENTS_REQUEST:
      return {
        ...state,
        placements: null,
      };
    case PlACEMENTS_SUCCESS:
      return {
        ...state,
        placements: action.payload,
      };
    case PlACEMENTS_CLEAN:
      return {
        ...state,
        placements: null,
      };
    //get type clients
    case TYPE_CLIENT_REQUEST:
      return {
        ...state,
        typeClient: null,
      };
    case TYPE_CLIENT_SUCCESS:
      return {
        ...state,
        typeClient: action.payload,
      };
    case TYPE_CLIENT_CLEAN:
      return {
        ...state,
        typeClient: null,
      };
    //get businesLines
    case BUSINESS_LINES_REQUEST:
      return {
        ...state,
        businessLine: null,
      };
    case BUSINESS_LINES_SUCCESS:
      return {
        ...state,
        businessLine: action.payload,
      };
    case BUSINESS_LINES_CLEAN:
      return {
        ...state,
        businessLine: null,
      };
    //get segmentation
    case SEGMENTATION_REQUEST:
      return {
        ...state,
        segmentation: null,
      };
    case SEGMENTATION_SUCCESS:
      return {
        ...state,
        segmentation: action.payload,
      };
    case SEGMENTATION_CLEAN:
      return {
        ...state,
        segmentation: null,
      };
    //get company
    case COMPANY_REQUEST:
      return {
        ...state,
        company: null,
      };
    case COMPANY_SUCCESS:
      return {
        ...state,
        company: action.payload,
      };
    case COMPANY_CLEAN:
      return {
        ...state,
        company: null,
      };
    //get Territoires
    case TERRITORIES_REQUEST:
      return {
        ...state,
        territories: null,
      };
    case TERRITORIES_SUCCESS:
      return {
        ...state,
        territories: action.payload,
      };
    case TERRITORIES_CLEAN:
      return {
        ...state,
        territories: null,
      };
    //get Pogs
    case POGS_REQUEST:
      return {
        ...state,
        pogs: null,
      };
    case POGS_SUCCESS:
      return {
        ...state,
        pogs: action.payload,
      };
    case POGS_CLEAN:
      return {
        ...state,
        pogs: null,
      };
    //get Currencies
    case CURRENCIES_REQUEST:
      return {
        ...state,
        currencies: null,
      };
    case CURRENCIES_SUCCESS:
      return {
        ...state,
        currencies: action.payload,
      };
    case CURRENCIES_CLEAN:
      return {
        ...state,
        currencies: null,
      };
    //get Currencies
    case REGISTER_CLIENT_REQUEST:
      return {
        ...state,
        registerClient: action.payload,
      };
    case REGISTER_CLIENT_SUCCESS:
      return {
        ...state,
        registerClient: action.payload,
      };
    case REGISTER_CLIENT_CLEAN:
      return {
        ...state,
        registerClient: action.payload,
      };

    default:
      return state;
  }
}

export default clientReducer;
